import { render, staticRenderFns } from "./InputRadioButtonSquared.vue?vue&type=template&id=af4d4008"
import script from "./InputRadioButtonSquared.vue?vue&type=script&lang=js"
export * from "./InputRadioButtonSquared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports